import { AppError } from "./app_error";
export class TimeoutBase {
    constructor(name, timeout, debugging) {
        this.debugging = false;
        this.pendingActions = new Map();
        this.name = name;
        this.timeout = timeout;
        if (debugging) {
            this.debugging = true;
        }
    }
    clear(timeoutId, id) {
        clearTimeout(timeoutId);
        this.pendingActions.delete(id);
    }
}
export class TimeoutWaiter extends TimeoutBase {
    has(id) {
        return this.pendingActions.has(id);
    }
    setTimeout(args, name) {
        if (typeof args.timeout !== 'number')
            args.timeout = this.timeout;
        let timeoutId = setTimeout(() => {
            if (this.pendingActions.delete(args.id)) {
                if (this.debugging) {
                    console.warn('setTimeout: name=%s, id=%s, timeout=%s', name || this.name, args.id, args.timeout);
                }
                if (args.callback)
                    args.callback(AppError.timeoutError(), null);
            }
        }, args.timeout);
        this.pendingActions.set(args.id, { callback: args.callback, timeoutId: timeoutId });
    }
    resetTimeout(args) {
        let obj = this.pendingActions.get(args.id);
        if (obj === undefined) {
            return false;
        }
        this.clear(obj.timeoutId, args.id);
        const callbackObject = args.callbackObject;
        if (callbackObject && obj.callback)
            obj.callback(callbackObject.error, callbackObject.result);
        return true;
    }
}
export class ProgressWaiter extends TimeoutBase {
    setTimeout(args, name) {
        if (typeof args.timeout !== 'number')
            args.timeout = this.timeout;
        let timeoutId = setTimeout(() => {
            if (this.pendingActions.delete(args.id)) {
                if (this.debugging) {
                    console.warn('setTimeout: name=%s, id=%s, timeout=%s', name || this.name, args.id, args.timeout);
                }
                if (args.timeoutCallback)
                    args.timeoutCallback(AppError.timeoutError(), args.context);
            }
        }, args.timeout);
        this.pendingActions.set(args.id, { callback: args.callback, timeoutId: timeoutId, context: args.context });
    }
    resetTimeout(args) {
        let obj = this.pendingActions.get(args.id);
        if (obj === undefined) {
            return false;
        }
        const ret = args.completing(obj.context);
        if (ret.done) {
            this.clear(obj.timeoutId, args.id);
        }
        const callbackObject = ret.callbackObject;
        if (callbackObject && obj.callback)
            obj.callback(callbackObject.error, callbackObject.result);
        return true;
    }
}
